module.exports = __webpack_public_path__ + "img/mk.b96b8a63.svg";